module.exports = __webpack_public_path__ + "static/media/kurv-green.af70d8ed.svg";


//////////////////
// WEBPACK FOOTER
// ./src/resources/icons/kurv-green.svg
// module id = 1634
// module chunks = 0